<ac-card>
  <ac-card-content>
    <div class="payments-offline">
      <app-purchase-dialog-header
        imageUrl="{{ 'cdnUrl' | env }}/images/payment_offline.webp"
        [imageSize]="60"
        [hideBack]="!showBack()"
        (close)="close.emit()"
        (back)="back.emit()"
      />

      <div class="payments-offline__copy">
        @if (cause() === 'sitewide') {
          <h2 class="ac-headline-sm payments-offline__title">We&rsquo;re Working on It</h2>
          <p class="ac-body-md ac-label payments-offline__body">
            Payments are temporarily unavailable due to ongoing maintenance. They&rsquo;ll be back online shortly.
          </p>
        } @else {
          <h2 class="ac-headline-sm payments-offline__title">Payments Unavailable</h2>
          <p class="ac-body-md ac-label payments-offline__body">
            Payments have been disabled on your account. If you think this was done by mistake please contact support.
          </p>
        }
      </div>

      <button
        type="button"
        class="payments-offline__got-it"
        (click)="close.emit()">
        Got it
      </button>

      @if (cause() === 'user') {
        <div class="ac-body-md ac-label payments-offline__support">
          Still experiencing issues?
          <a class="ac-link ac-title-sm" (click)="openSupport()">Contact Support</a>
        </div>
      }
    </div>
  </ac-card-content>
</ac-card>
